type SortableEvent = {
    date: Date;
    status: "upcoming" | "active" | "ended";
    featuredOrder: number | null;
};

/** Active/upcoming events are shown in the carousels; ended ones in the tables. */
export function isCarouselEvent(event: Pick<SortableEvent, "status">) {
    return event.status !== "ended";
}

/**
 * Carousel events come first, ranked by FeaturedOrder (lower first, unset last).
 * Everything else is sorted by date, earliest first.
 */
export function compareEvents(a: SortableEvent, b: SortableEvent): number {
    const aCarousel = isCarouselEvent(a);
    const bCarousel = isCarouselEvent(b);
    if (aCarousel !== bCarousel) return aCarousel ? -1 : 1;

    if (aCarousel) {
        const orderDiff =
            (a.featuredOrder ?? Number.MAX_SAFE_INTEGER) -
            (b.featuredOrder ?? Number.MAX_SAFE_INTEGER);
        if (orderDiff !== 0) return orderDiff;
    }

    return a.date.getTime() - b.date.getTime();
}
